import React  from "react";
import { useRecoilValue } from "recoil";
import { useHistory, useLocation, useParams } from "react-router-dom";
import PropTypes from "prop-types";
// TODO: re-enable next sprint
// import styles from "./ProviderGamesAccordionList.scss";
import filter from "lodash/filter";
import includes from "lodash/includes";
import map from "lodash/map";
import { providerGameTemplateListState } from "state/providerGameTemplateState";
// TODO: re-enable next sprint
// import Accordion from "components/common/Accordion";
// import AccordionSection from "components/common/AccordionSection";
import ProviderGameInfoTable from "components/provider/widgets/ProviderGameInfoTable";
// TODO: re-enable next sprint
// import pluralizeWord from "utils/pluralizeWord";
import * as ProviderLinks from "utils/ProviderLinks";
import { parseQueryString } from "utils/urls";

const SECTIONS = [{
    id: "active_templates",
    label: "Active Templates",
// TODO: re-enable this section next sprint
// }, {
//     id: "inactive_templates",
//     label: "Inactive Templates",
}]

export default function GameTemplateAccordionList({ userId }) {
    const filters = { userId };
    const location = useLocation();
    const history = useHistory();
    const params = useParams();
    const parsedFilters = parseQueryString(location.search);
    const nodeId = Number(params.nodeId);
    const providerId = Number(params.providerId);
    const isAdmin = !!(includes(location.pathname, "/admin") && providerId && nodeId);
    const templates = useRecoilValue(providerGameTemplateListState(filters));

    const getCopyTemplateLink = (template) => {
        let link;
        let linkName;
        let templateId;
        if (template.greenlineGameId) {
            linkName = "game-copy";
            templateId = template.greenlineGameId;
        } else if (template.greenlineGameTemplateId) {
            linkName = "game-template";
            templateId = template.greenlineGameTemplateId;
        }

        if (linkName && templateId) {
            if (userId) {
                link = ProviderLinks.getLinkLocation(linkName, {
                    providerId: providerId,
                    nodeId: nodeId,
                    isAdmin: isAdmin,
                    templateId,
                }, `?userId=${userId}`)
            } else {
                link = ProviderLinks.getLinkLocation(linkName, {
                    providerId: providerId,
                    nodeId: nodeId,
                    isAdmin: isAdmin,
                    templateId,
                });
            }

            if (!!link) {
                history.push(link);
            }
        }
    }

    const renderSection = (section) => {
        let sectionTemplates;
        if (section.id === "active_templates") {
            // sectionTemplates = filter(templates, { isActive: true });
            sectionTemplates = templates;
        } else {
            sectionTemplates = filter(templates, { isActive: false });
        }

        const hasTemplates = !!sectionTemplates;
        // TODO: re-enable next sprint
        // const templateCount = hasTemplates ? sectionTemplates.length : 0;

        // const renderSubText = (
        //     <div className="flex-none no-wrap text-mid-gray text-sm">
        //         {(!!templateCount ? `${templateCount} ${pluralizeWord(templateCount, "template")}` : "none")}
        //     </div>
        // )

        return (
            <>
            {/* TODO: re-enable the accordion sections next sprint */}
            {/*<AccordionSection*/}
            {/*    key={section.id}*/}
            {/*    id={section.id}*/}
            {/*    header={section.label}*/}
            {/*    headerSubtext={renderSubText}*/}
            {/*    onClick={() => {}}*/}
            {/*>*/}
                {!hasTemplates && <div>No data available</div>}
                {hasTemplates && (
                    <ProviderGameInfoTable
                        games={sectionTemplates}
                        isTemplates
                        nodeId={nodeId}
                        onUse={getCopyTemplateLink}
                        providerId={providerId}
                        search={parsedFilters.search}
                        userId={userId}
                    />
                )}
            {/*</AccordionSection>*/}
            </>
        );
    };

    const hasTemplates = !!templates.length;

    return (
        <div className="full-width full-height">
            {/* TODO: re-enable next sprint */}
            {/*<Accordion*/}
            {/*    theme={{*/}
            {/*        header: styles.header,*/}
            {/*        collapse: styles.collapse,*/}
            {/*    }}*/}
            {/*>*/}
                {hasTemplates ? (
                    map(SECTIONS, section => renderSection(section))
                ) : (
                    <h2 className="flex justify-flex-center align-center margin-lg text-italic text-gray">No Templates for this User</h2>
                )}
            {/*</Accordion>*/}
        </div>
    );
}

GameTemplateAccordionList.propTypes = {
    templates: PropTypes.object,
};
